import InscriptionCamp from './InscriptionCamp';

export default InscriptionCamp;
